<template>
  <div class="container">
    <a-breadcrumb style="padding: 16px 0; background: #f0f2f5">
      <a-breadcrumb-item>单位管理</a-breadcrumb-item>
      <a-breadcrumb-item>单位信息</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="mainBox" style="padding: 24px">
      <div style="width: 80%; margin: 0px auto">
        <a-form-model ref="abc" :model="tmp" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
          <div class="form-title">单位信息</div>
          <a-form-model-item label="食堂名称">
            <a-input v-model="tmp.title" style="width: 400px" />
          </a-form-model-item>
          <a-form-model-item label="单位性质">
            <a-select v-model="tmp.type" style="width: 400px" @change="changeType" :options="options">
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="管理员账号">
            <a-input v-model="tmp.username" style="width: 400px" />
          </a-form-model-item>
          <div class="form-title">联系人信息</div>
          <a-form-model-item label="姓名">
            <a-input v-model="tmp.name" style="width: 400px" />
          </a-form-model-item>
          <a-form-model-item label="邮箱">
            <a-input v-model="tmp.email" style="width: 400px" />
          </a-form-model-item>
          <a-form-model-item label="手机号">
            <a-input v-model="tmp.mobile" style="width: 400px" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 3 }">
            <a-button type="primary" @click="doEditInstInfo"> 提交 </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  canteenDetail,
  canteenEdit,
} from "@/request/api";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
  },
  data () {
    return {
      tmp: {
        id: "",
        title: "",
        type: undefined,
        name: "",
        mobile: "",
        email: "",
        username: ""
      },
      options: [
        {
          value: 1,
          label: "行政事业单位",
        },
        {
          value: 2,
          label: "国有企业",
        },
        {
          value: 3,
          label: "民营企业",
        },
        {
          value: 4,
          label: "园区/社区",
        },
        {
          value: 5,
          label: "其他",
        },
      ]
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    instInfo () {
      canteenDetail().then((res) => {
        let canteen = res.data.result.canteen;
        let staff = res.data.result.staff;
        console.log(canteen)
        this.tmp = {
          title: canteen.title,
          type: canteen.type,
          name: canteen.name,
          mobile: canteen.mobile,
          email: canteen.email,
          username: staff.username
        };
      });
    },
    changeType (v) {
      this.tmp.type = v;
    },
    
    doEditInstInfo () {
      let p = {
        title: this.tmp.title,
        type: this.tmp.type,
        name: this.tmp.name,
        mobile: this.tmp.mobile,
        email: this.tmp.email,
        //province: this.tmp.province,
        //city: this.tmp.city,
        //county: this.tmp.county,
        username: this.tmp.username
      };
      canteenEdit(p)
      .then((res) => {
        if(res.data.result>0){
          this.$message.success("操作成功");
        }
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.instInfo();
  },
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.controlBox {
  display: flex;
  .btn {
    margin-bottom: 10px;
    margin-right: 20px;
  }
}
.e-space {
  margin-left: 10px;
}
.mr-10 {
  margin-right: 10px;
}
.form-title{
	font-weight: 900;
	padding:12px 0 12px 20px;
}
</style>